const WEB_SOCKET_PROTOCOLS = new Set(['http:', 'https:', 'ws:', 'wss:']);

/**
 * Resolves either a configured WebSocket URL or the current application origin.
 * HTTP(S) inputs are normalized to WS(S); the origin fallback always targets /ws.
 */
export function resolveWebSocketUrl(origin: string, configuredUrl?: string | null): string {
  const trimmedUrl = configuredUrl?.trim();
  const hasConfiguredUrl = Boolean(trimmedUrl);

  let resolvedUrl: URL;
  try {
    resolvedUrl = new URL(trimmedUrl || origin, origin);
  } catch {
    throw new Error('Invalid WebSocket URL');
  }

  if (!WEB_SOCKET_PROTOCOLS.has(resolvedUrl.protocol)) {
    throw new Error(`Unsupported WebSocket URL protocol: ${resolvedUrl.protocol}`);
  }

  if (resolvedUrl.username || resolvedUrl.password || resolvedUrl.hash) {
    throw new Error('WebSocket URL must not contain credentials or a fragment');
  }

  resolvedUrl.protocol = resolvedUrl.protocol === 'https:' || resolvedUrl.protocol === 'wss:'
    ? 'wss:'
    : 'ws:';

  if (!hasConfiguredUrl) {
    resolvedUrl.pathname = '/ws';
    resolvedUrl.search = '';
  }

  return resolvedUrl.toString();
}
